import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import WorkGrid from '../components/Work/WorkGrid';
import PortfolioGrid from '../components/Portfolio/PortfolioGrid';
import Awards from '../components/Awards';
import Contact from '../components/Contact';

const Home = () => (
  <>
    <Hero />
    <About />
    <WorkGrid />
    <PortfolioGrid />
    <Awards />
    <Contact />
  </>
);

export default Home;
